import { IAccBienLaiThietLap } from "../../model/respone/category/IAccBienLaiThietLap";
import { apiClient } from "../apiClient";
export const BIEN_LAI_THIET_LAP_ENDPOINT = "bien-lai-thiet-lap";
export const bienLaiThietLapApi = {
  SelectAll: () => apiClient.get(`${BIEN_LAI_THIET_LAP_ENDPOINT}`),
  Insert: (payload: IAccBienLaiThietLap) =>
    apiClient.post(`${BIEN_LAI_THIET_LAP_ENDPOINT}`, payload),
  Update: (payload: IAccBienLaiThietLap) =>
    apiClient.put(`${BIEN_LAI_THIET_LAP_ENDPOINT}`, payload),
  Delete: (id: number) =>
    apiClient.delete(`${BIEN_LAI_THIET_LAP_ENDPOINT}/${id}`),
};
